<script>
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";
</script>

<div class="title-content">
  <h3 class="title">Categories</h3>
</div>
<div class="catagories-area">
  <div class="catagories-nav-1">
    <!-- Additional required wrapper -->
    <Swiper
      class="swiper swiper-initialized swiper-horizontal swiper-pointer-events"
      spaceBetween={10}
      slidesPerView={3}
      loop={true}
      loopFillGroupWithBlank={true}
    >
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/SHIRT?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-shirt-64.png"
              alt="product"
            /></span
          >Shirt</Link
        >
      </SwiperSlide>

      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/T SHIRT?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-t-shirt-64.png"
              alt="product"
            /></span
          >T Shirt</Link
        >
      </SwiperSlide>

      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/PANT?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-trousers-64.png"
              alt="product"
            /></span
          >Pants</Link
        >
      </SwiperSlide>

      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/BRIEF?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-briefs-64.png"
              alt="product"
            /></span
          >Briefs</Link
        >
      </SwiperSlide>

            
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/VEST?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-basketball-jersey-64.png"
              alt="product"
            /></span
          >Vests</Link
        >
      </SwiperSlide>
      
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/JACKET?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-jackets-64.png"
              alt="product"
            /></span
          >Jackets</Link
        >
      </SwiperSlide>

      
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/JEANS?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-jeans-64.png"
              alt="product"
            /></span
          >Jeans</Link
        >
      </SwiperSlide>

      
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/SHORTS?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-shorts-64.png"
              alt="product"
            /></span
          >Shorts</Link
        >
      </SwiperSlide>

      
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/TRACKPANT?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-fencing-pants-64.png"
              alt="product"
            /></span
          >Tracks</Link
        >
      </SwiperSlide>

      
      <SwiperSlide class="swiper-slide">
        <Link to="/shop/filter/TRUNK?page=0" class="btn"
          ><span class="icon"
            ><img
              width="33"
              height="33"
              src="assets/images/catagories/icons8-shorts.png"
              alt="product"
            /></span
          >Trunk</Link
        >
      </SwiperSlide>

    </Swiper>
  </div>
</div>
